import { render, staticRenderFns } from "./TreatmentWarningModal.vue?vue&type=template&id=1f9af19b&scoped=true"
import script from "./TreatmentWarningModal.vue?vue&type=script&lang=js"
export * from "./TreatmentWarningModal.vue?vue&type=script&lang=js"
import style0 from "./TreatmentWarningModal.vue?vue&type=style&index=0&id=1f9af19b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9af19b",
  null
  
)

export default component.exports